import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

export default class extends BridgeComponent {
  static component = 'open-health';

  open() {
    this.send('open');
  }
}
